import { lazy } from 'react'

export const SocialProofVariant1 = lazy(() => import('./SocialProofVariant1'))
export const SocialProofVariant2 = lazy(() => import('./SocialProofVariant2'))
export const SocialProofVariant3 = lazy(() => import('./SocialProofVariant3'))
export const SocialProofVariant22 = lazy(() => import('./SocialProofVariant22'))
export const SocialProofVariant23 = lazy(() => import('./SocialProofVariant23'))
export const SocialProofVariant24 = lazy(() => import('./SocialProofVariant24'))
